import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center text-xl">
                <i className="ri-magic-line text-accent-400"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                在线麻将牌
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              免费在线麻将游戏平台，随时随地享受正宗麻将乐趣。支持多种玩法，与全国玩家实时对战。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/guobiao" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  玩法分类
                </Link>
              </li>
              <li>
                <Link to="/articles" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  麻将攻略
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              热门玩法
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/guobiao" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  国标麻将
                </Link>
              </li>
              <li>
                <Link to="/category/guangdong" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  广东麻将
                </Link>
              </li>
              <li>
                <Link to="/category/sichuan" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  四川麻将
                </Link>
              </li>
              <li>
                <Link to="/category/changsha" className="text-sm text-background-400 hover:text-accent-400 transition-colors">
                  长沙麻将
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <span>support@mahjong-online.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-line mt-0.5 text-accent-400"></i>
                <span>在线客服：每日 9:00 - 22:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                <span>中国 · 北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 在线麻将牌 - 版权所有 | 免费在线麻将 | 麻将牌游戏 | 网页麻将
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-background-500 hover:text-accent-400 transition-colors"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-background-500 hover:text-accent-400 transition-colors"
              rel="nofollow"
            >
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}